module.exports = __webpack_public_path__ + "img/logo-160x220.5bdf3678.png";